import {clsx} from 'clsx'

import type {HeadingSizes} from '@primer/react-brand/esm'

import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import type {PrimerComponentSectionIntro} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSectionIntro'

import styles from './Section.module.css'

type Props = {
  children: React.ReactNode
  className?: string
  headingSize?: (typeof HeadingSizes)[number]
  id?: string
  introClassName?: string
  introComponent?: PrimerComponentSectionIntro
  withBorder?: boolean
}

export function Section(props: Props) {
  const {
    children,
    className = '',
    headingSize = '3',
    id,
    introClassName = '',
    introComponent,
    withBorder = false,
  } = props

  return (
    <section className={clsx(styles.section, {[styles.withBorder]: withBorder}, className)} id={id}>
      {introComponent ? (
        <ContentfulSectionIntro
          component={introComponent}
          className={clsx(styles.intro, introClassName)}
          headingSize={headingSize}
        />
      ) : null}

      {children}
    </section>
  )
}
